import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";

export default function ServicePricingContent({ service, imgSrc }) {
  return (
    <>
      <Grid
        sx={{
          // width: "300px",
          padding: "30px 10px",
          border: "1px solid #dae0ea",
          borderRadius: "4px",
          bg: "white",
          marginBottom: "30px",
        }}
        templateRows="auto 1fr"
        // className="card"
      >
        <Box>
          <Text
            sx={{
              textTransform: "uppercase",
              textAlign: "center",
              color: "#3981C5",
              letterSpacing: "1px",
              lineHeight: "23px",
              fontSize: "18px",
              fontWeight: 500,
            }}
            className="title"
          >
            {service.name}
          </Text>
          <Center my="9">
            <Image height={150} src={imgSrc} alt={`${service.name} package`} />
          </Center>
          <hr />
        </Box>

        <Grid>
          <Stack
            mt="6"
            sx={{ textAlign: "center" }}
            direction={["column"]}
            spacing="20px"
          >
            {service.userMgt && (
              <Box>
                <Text>User Management</Text>
              </Box>
            )}

            {service.courseMgt && (
              <Box>
                <Text>Course Management</Text>
              </Box>
            )}

            {service.analytics && (
              <Box>
                <Text>Analytics</Text>
              </Box>
            )}

            {service.learnersCertification && (
              <Box>
                <Text>Learners Certification</Text>
              </Box>
            )}

            {service.basicSetting && (
              <Box>
                <Text>Basic Setting</Text>
              </Box>
            )}

            {service.advancedSetting && (
              <Box>
                <Text>Advanced Setting</Text>
              </Box>
            )}

            {service.automaticOnboarding && (
              <Box>
                <Text>Automatic Onboarding</Text>
              </Box>
            )}

            {service.entranceExam && (
              <Box>
                <Text>Entrance Exam</Text>
              </Box>
            )}

            {service.learnersSurvey && (
              <Box>
                <Text>Learners Survey</Text>
              </Box>
            )}

            {service.numberOfUsers && (
              <Box>
                <Text>maximum of {service.numberOfUsers} users</Text>
              </Box>
            )}

            {service.storage && (
              <Box>
                <Text>{service.storage} Storage Capacity</Text>
              </Box>
            )}
          </Stack>

          <Flex
            justify="center"
            sx={{ alignSelf: "flex-end", flexDirection: "column" }}
          >
            <Box mt="5" sx={{ textAlign: "center" }}>
              <Text
                sx={{
                  color: "#3981C5",
                  textTransform: "capitalize",
                  fontSize: "30px",
                  fontWeight: "bold",
                }}
              >
                ${service.duration[0].price}
              </Text>
              <Text
                sx={{
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  lineHeight: "23px",
                  fontSize: "18px",
                  mt: 2,
                }}
              >
                {service.duration[0].timeLength}
              </Text>
            </Box>

            <Button
              isFullWidth
              sx={{
                textDecoration: "none",
                ":hover, :focus": { textDecoration: "none" },
                py: "6",
                mt: "5",
                border: "2px solid #3981C5",
                borderRadius: "100px",
                color: "#3981C5",
              }}
              as="a"
              href={`/services/${service.name}`}
            >
              Subscribe
            </Button>
          </Flex>
        </Grid>
      </Grid>
    </>
  );
}
